import React from "react";
import { GlassyModal } from "../glassy-modal/glassy-modal";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { ScanLoadingLinearIndicator } from "@src/components/molecules/scan-loading-linear-indicator/scan-loading-linear-indicator";
import styles from "./ota-configuration-backup-install-modal.module.scss";
import { ListItem } from "@src/types/ota-update";
import { formatBytes } from "@src/cloud-connect/utils/format-bytes";
import closeIcon from "@src/assets/svg/close-icon.svg";
import { useOtaConfigurationBackupInstallModal } from "./use-ota-configuration-backup-install-modal";

const cssClassName = "ota-configuration-backup-install-modal";
interface OtaConfigurationInstallModalProps {
  data: ListItem | null;
  installUpdateId: string | null;
  setInstallUpdateId: React.Dispatch<React.SetStateAction<string | null>>;
}

const OtaConfigurationBackupInstallModal = ({
  data,
  installUpdateId,
  setInstallUpdateId,
}: OtaConfigurationInstallModalProps) => {
  const { progress, texts, closeModalFromXIcon } =
    useOtaConfigurationBackupInstallModal({
      installUpdateId,
      setInstallUpdateId,
    });

  if (!data) return null;

  return (
    <div className={styles[cssClassName]}>
      <GlassyModal>
        <div className={styles[`${cssClassName}__modal-body`]}>
          <GlassyModalHeader
            title={texts.installingConfigurationText}
            rightIcon={closeIcon}
            rightIconFunction={closeModalFromXIcon}
          />

          <HorizontalSeparator verticalMargin={16} />

          <div className={styles[`${cssClassName}__content`]}>
            <h4 className={styles[`${cssClassName}__title`]}>
              {texts.installConfigurationOnDeviceText}
            </h4>

            <p className={styles[`${cssClassName}__description`]}>
              {texts.descriptionText}
            </p>

            <div className={styles[`${cssClassName}__firmware-info`]}>
              <div className={styles[`${cssClassName}__info-row`]}>
                <span className={styles[`${cssClassName}__label`]}>
                  {texts.configurationText}
                </span>
                <span className={styles[`${cssClassName}__value`]}>
                  {data.filename}
                </span>
              </div>

              <div className={styles[`${cssClassName}__info-row`]}>
                <span className={styles[`${cssClassName}__label`]}>
                  {texts.versionText}
                </span>
                <span className={styles[`${cssClassName}__value`]}>
                  {data.version}
                </span>
              </div>

              <div className={styles[`${cssClassName}__info-row`]}>
                <span className={styles[`${cssClassName}__label`]}>
                  {texts.digestText}
                </span>
                <span className={styles[`${cssClassName}__value`]}>
                  {data.digest}
                </span>
              </div>

              <div className={styles[`${cssClassName}__info-row`]}>
                <span className={styles[`${cssClassName}__label`]}>
                  {texts.sizeText}
                </span>
                <span className={styles[`${cssClassName}__value`]}>
                  {formatBytes(data.size_bytes)}
                </span>
              </div>
            </div>
          </div>

          <Spacer16 />

          <div
            className={
              styles[`${cssClassName}__connection-loading-indicator-wrapper`]
            }
          >
            <ScanLoadingLinearIndicator />

            <p className={styles[`${cssClassName}__progress-text`]}>
              {texts.progressText} {progress}%
            </p>
          </div>
        </div>
      </GlassyModal>
    </div>
  );
};

export default OtaConfigurationBackupInstallModal;
